import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// styles
import {
  BulletedListStyled,
  ColStyled,
  LinkStyled,
  TypographyStyled,
} from '../styles';

const baseIdPrefix = 'sitemap-financial-planning';
const baseIdSuffix = 'link';

const bulletedListConfig = [
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-financial-planning-${baseIdSuffix}`}
        linkUrl='/financial-planning/'
        variant='primaryDeemphasize'>
        Financial Planning
      </Link>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-retirement-planning-${baseIdSuffix}`}
          linkUrl='/retirement-planning/'
          variant='primaryDeemphasize'>
          Retirement Planning
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-retirement-calculator-${baseIdSuffix}`}
                  linkUrl='/retirement-planning/retirement-calculator/'
                  variant='primaryDeemphasize'>
                  Retirement Calculator
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-non-qualified-retirement-plan-${baseIdSuffix}`}
                  linkUrl='/financial-planning/retirement-planning/non-qualified-retirement-plan/'
                  variant='primaryDeemphasize'>
                  Non&#45;Qualified Retirement Plan
                </Link>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-college-savings-plans-${baseIdSuffix}`}
          linkUrl='/college-savings-plans/'
          variant='primaryDeemphasize'>
          College Savings Plans
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-529-college-savings-${baseIdSuffix}`}
                  linkUrl='/529-college-savings-plans/'
                  variant='primaryDeemphasize'>
                  529 College Savings
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-save-for-college-${baseIdSuffix}`}
                  linkUrl='/save-for-college/'
                  variant='primaryDeemphasize'>
                  Save for College
                </Link>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-private-wealth-management-${baseIdSuffix}`}
        linkUrl='/private-wealth-management/'
        variant='primaryDeemphasize'>
        Private Wealth Management
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-estate-planning-${baseIdSuffix}`}
        linkUrl='/financial-planning/estate-planning/'
        variant='primaryDeemphasize'>
        Estate Planning
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-long-term-care-${baseIdSuffix}`}
        linkUrl='/long-term-care-planning/'
        variant='primaryDeemphasize'>
        Long&#45;Term Care
      </Link>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-business-services-${baseIdSuffix}`}
          linkUrl='/financial-planning/business-services/'
          variant='primaryDeemphasize'>
          Business Services
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-business-risk-management-${baseIdSuffix}`}
                  linkUrl='/financial-planning/business-risk-management/'
                  variant='primaryDeemphasize'>
                  Business Risk Management
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-employee-benefits-planning-${baseIdSuffix}`}
                  linkUrl='/financial-planning/business-services/employee-benefits-planning/'
                  variant='primaryDeemphasize'>
                  Employee Benefits Planning
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-business-succession-planning-${baseIdSuffix}`}
                  linkUrl='/financial-planning/business-services/business-succession-planning/'
                  variant='primaryDeemphasize'>
                  Business Succession Planning
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-personal-financial-planning-${baseIdSuffix}`}
                  linkUrl='/financial-planning/business-services/personal-financial-planning/'
                  variant='primaryDeemphasize'>
                  Personal Financial Planning
                </Link>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-save-for-retirement-${baseIdSuffix}`}
        linkUrl='/save-for-retirement/'
        variant='primaryDeemphasize'>
        Save for Retirement
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-buy-a-home-${baseIdSuffix}`}
        linkUrl='/buy-a-home/'
        variant='primaryDeemphasize'>
        Buy a Home
      </Link>
    ),
  },
];

export default () => (
  <ColStyled
    medium={6}
    id='sitemap-financial-planning-list'>
    <TypographyStyled
      component='h2'
      variant='h3'
      nextElement='typography'>
      Financial Planning
    </TypographyStyled>
    <BulletedListStyled
      bulletedListData={bulletedListConfig}
      bulletType='none'/>
  </ColStyled>
);
